<template>
  <v-app class="bg-light-blue">
    <v-container :fluid="false" class="global_container">
      <page-not-load v-if="instanceNotLoad"/>
      <router-view v-else/>
    </v-container>
  </v-app>
</template>

<script>
import { defineComponent } from "vue"
import { mapGetters } from "vuex"
import PageNotLoad from "@/modules/core/pages/PageNotLoad.vue"

export default defineComponent({
  components: {
    PageNotLoad
  },
  computed: {
    ...mapGetters({
      instanceNotLoad: 'urls/getInstanceNotLoad',
    }),
  },
})

</script>

<style lang="scss">
#app {
  font-family: Montserrat;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  //color: #2c3e50;
}
</style>
